export interface Review {
  id: string;
  author: string;
  avatar: string;
  score: number;
  tag: string;
  title: string;
  content: string;
  likes: number;
  date: string;
}

const avatarColors = [
  "bg-primary-200 text-primary-800",
  "bg-secondary-200 text-secondary-800",
  "bg-accent-200 text-accent-900",
  "bg-primary-100 text-primary-700",
];

export const reviews: Review[] = [
  {
    id: "r1",
    author: "追更到凌晨的猫",
    avatar: avatarColors[0],
    score: 9,
    tag: "结局考据党",
    title: "结局二刷之后，我才看懂那句「再见」",
    content: "第一次看结局只觉得意难平，二刷才发现导演把伏笔埋得有多深。那句「没说出口的再见」其实一直都在讲「学会告别」，讲给阿浩，也讲给屏幕前的我们。看完这篇深度解析，直接封神。",
    likes: 1264,
    date: "2026-08-16",
  },
  {
    id: "r2",
    author: "小林的忠实听众",
    avatar: avatarColors[1],
    score: 8,
    tag: "人物党",
    title: "小林这条支线被严重低估了",
    content: "主角团固然出彩，但我更心疼小林。他承包了全剧一半笑点，背后却是「普通人的选择」——没有惊天动地的转折，只有日复一日的坚持。这种真实感是我留在这个故事里的理由。",
    likes: 883,
    date: "2026-08-14",
  },
  {
    id: "r3",
    author: "HEIMATE酱",
    avatar: avatarColors[2],
    score: 10,
    tag: "治愈系",
    title: "嘿咻猫咪治愈了我一整年",
    content: "今年最感谢的设定就是嘿咻猫咪。它不说话，但每次趴在阿浩桌上那个画面，都能让我在加完班的深夜笑出声。漫画能抚慰人心的最高形式，大概就是这样的日常吧。",
    likes: 1521,
    date: "2026-08-11",
  },
  {
    id: "r4",
    author: "十年之约见证人",
    avatar: avatarColors[3],
    score: 9,
    tag: "主线党",
    title: "十年之约不是套路，是浪漫的笨拙",
    content: "看多了套路式的承诺，这对青梅竹马反而让人眼前一亮。他们没喊口号，只是各自努力、彼此守护，最后用一场普通的黄昏兑现了约定。我愿意为这种笨拙的浪漫买单。",
    likes: 732,
    date: "2026-08-08",
  },
  {
    id: "r5",
    author: "分镜显微镜",
    avatar: avatarColors[0],
    score: 8,
    tag: "考据党",
    title: "每一格分镜都在暗示结局",
    content: "如果你是考据党，强烈建议带着伏笔盘点文再刷一遍。很多我以为只是「氛围感」的空镜，回头一看全是线索。作者的分镜功力是真的扎实，细节控狂喜。",
    likes: 645,
    date: "2026-08-05",
  },
  {
    id: "r6",
    author: "纸片人收藏家",
    avatar: avatarColors[1],
    score: 9,
    tag: "新人友好",
    title: "新人入坑完全无压力",
    content: "本来担心追一部有年代的漫画会看不懂，结果导读文章两三篇就理清了人物关系。节奏很稳，前几话就把世界观和人物立住了，非常适合我刚入坑的阅读习惯。",
    likes: 419,
    date: "2026-08-01",
  },
];